import { Alert, Alignment, Button, Checkbox, Classes, Collapse, Dialog, FormGroup, HTMLSelect, Tab, Tabs, Tag } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { TarefasStore } from "../../stores/notas/TarefasStore";
import { Pager } from "../utils/Pager";
import { formatCnpj } from "../../utils";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";

export const MODELOS_NOTA = [
  { id: "NFE_ENTRADA", rotulo: "NFE-Entrada" },
  { id: "NFE_SAIDA", rotulo: "NFE-Saída" },
  { id: "NFCE_SAIDA", rotulo: "NFCE-Saída" },
  { id: "CTE_ENTRADA", rotulo: "CTE-Entrada" },
  { id: "CTE_SAIDA", rotulo: "CTE-Saída" },
  { id: "CANCELADAS", rotulo: "Canceladas" },
];

@observer
export class TarefasPage extends React.Component<{}, {}> {

  obs = observable({
    date_start: "" as string,
    date_end: "" as string,
    selectEmpresa: newEmpresa() as IEmpresa,
    current_page: 1 as number,
    erros_nfses: [] as any,
    avisos_nfses: [] as any,
    panel: [] as any,
    modelo: "" as string,
    finalidade_arquivo: "0" as string,
    showErrors: false as boolean,
    showAvisos: false as boolean,
    notas_selecionadas: [] as any,
  })

  constructor(props: any) {
    super(props);
    AppStore.setTitle("NF-e, NFC-e, CT-e e NFS-e");
    TarefasStore.handleTasksPaged(1);

    this.obs.notas_selecionadas = MODELOS_NOTA.map(n => n.id);
  }

  async handleChangePage(page: number) {
    this.obs.current_page = page
    await TarefasStore.handleTasksPaged(this.obs.current_page)
  }

  handleDetalhesSolicitacao(row: any) {

    let erros = [];

    if (row.erros) {
      erros.push({ erros: row.erros });
    }

    this.obs.erros_nfses = erros;

    let avisos = [];
    if (row.avisos) {
      avisos.push({ erros: row.avisos });
    }
    this.obs.avisos_nfses = avisos;

    TarefasStore.obs.open_detalhes_nfses = true;
  }

  handleCloseDetalhes() {
    this.obs.showErrors = false
    this.obs.showAvisos = false
    TarefasStore.obs.open_detalhes_nfses = false
    this.obs.erros_nfses = []
    this.obs.avisos_nfses = []
  }

  render() {
    this.obs.selectEmpresa.cnpj != "" ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})` : "Selecione uma empresa";

    function statusFormatter(cell, row) {

      if ((row.status == 2 && row.total_chaves == row.qtd_processada) || (row.status == 3 && row.error == true) || row.status < 2 || row.status > 3) {

        return getTag(row.status);

      }

      return getTag(1);

    }

    function fileFormatter(cell, row) {

      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={row.status != 2 && row.status != 4}
            onClick={() => TarefasStore.handleDownloadArquivoNfse(row)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    const detalhesFormatter = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            disabled={row.status != 3}
            rounded
            size="sm"
            onClick={() => this.handleDetalhesSolicitacao(row)}
          >
            <img src="/images/view.png" />
          </MDBBtn>
        </>
      );
    }

    let items = TarefasStore.obs.tasks_nfses?.map(imp => {
      return (
        {
          id: imp._id,
          cnpj: imp.cnpj,
          razao_social: imp.razao_social,
          inserted_at: imp.inserted_at,
          date_start: imp.date_start,
          date_end: imp.date_end,
          status: imp.status,
          total_chaves: imp.total_chaves,
          qtd_processada: imp.qtd_processada,
          error: imp.error ?? null,
          erros: imp.erros ?? null,
          avisos: imp.avisos ?? null,
          dominio: imp.dominio
        }
      );
    });

    const dateFormatter = (cell, row) => {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    };

    const cnpjFormatter = (cell, row) => {
      return formatCnpj(row.cnpj)
    };

    return (
      <>
        <MDBCol>
          <MDBRow>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => TarefasStore.handleTasksPaged(1)}>Atualizar</MDBBtn>
          </MDBRow>
        </MDBCol>

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={items}
            data-tut="table"
          >
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data do Agendamento</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="date_start" width="15%">Período Inicial</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="date_end" width="15%">Período Final</TableHeaderColumn>
            <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="40%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={detalhesFormatter} width="10%">Erros</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={TarefasStore.obs.length_tasks_nfses}
            pageSize={15}
            onPageChange={page => this.handleChangePage(page)}
          />
        </div>

        <LoadingModal open={TarefasStore.obs.loading} onClose={() => TarefasStore.obs.loading = false} title={"Baixando arquivo"} />

        <Alert
          confirmButtonText="Fechar"
          isOpen={TarefasStore.obs.open_detalhes_nfses}
          onClose={() => this.handleCloseDetalhes()}
          onConfirm={() => this.handleCloseDetalhes()}
          canOutsideClickCancel={true}
          className="AlertErrorSped"
        >
          <h2 className="titleSEFAZ">Erros</h2>

          <MDBCol md="12">
            {this.obs.erros_nfses.length > 0 &&
              <div className="errosSped">
                <BootstrapTable className="nomeArquivos" data={this.obs.erros_nfses} hover>
                  <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                  <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                </BootstrapTable>
              </div>
            }
          </MDBCol>

          {this.obs.avisos_nfses.length > 0 &&
            <>
              <h3 className="titleSEFAZ" style={{ marginTop: 20 }}>Avisos</h3>
              <MDBCol md="12">
                <div className="errosSped">
                  <BootstrapTable className="nomeArquivos" data={this.obs.avisos_nfses} hover>
                    <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                    <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                  </BootstrapTable>
                </div>
              </MDBCol>
            </>
          }

        </Alert>

      </>
    )
  }
}

export default TarefasPage;
